import React from 'react'
import { Helmet } from 'react-helmet-async'
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3'

import UserLayout from '../components/UserLayout.jsx'
import UISwitchChecker from '../../../global/practice/components/PracticeUISwitcher.jsx'
import UserRegisterForm from '../components/UserRegisterForm.jsx'
import UserAccountSetupForm from '../components/UserAccountSetupForm.jsx'

import { RECAPTCHA_SITE_KEY } from '../../../config/constants.js'

const UserRegister = () => {
  const jwt = window.location.hash.substring(1)

  return (
    <UserLayout>
      <UISwitchChecker />
      <Helmet>
        <title>Sign up to {window.brandingSettings.title}</title>
      </Helmet>
      <div className="yt-container">
        <div className="yt-row center-horiz">
          <GoogleReCaptchaProvider
            reCaptchaKey={RECAPTCHA_SITE_KEY}
            useEnterprise={true}
            scriptProps={{ async: true, defer: true, appendTo: 'head' }}
          >
            {!jwt ? (
              <UserRegisterForm />
            ) : (
              <UserAccountSetupForm emailToken={jwt} />
            )}
          </GoogleReCaptchaProvider>
        </div>
      </div>
    </UserLayout>
  )
}

export default UserRegister
